import { c as _c } from "react/compiler-runtime";
import { HotelListHeaderTitlePropertiesType } from "@website/accommodation-ui/hotel-list-header/hotel-list-header.types";
import { Skeleton } from "@website/ui/skeleton";
import { numberConvert } from "@website/utils/number-convert";
import { useRouter } from "next/router";
import { FC } from "react";
export const HotelCityTitle: FC<HotelListHeaderTitlePropertiesType> = t0 => {
  const $ = _c(11);
  const {
    city,
    totalItem,
    hasCityPrefix: t1,
    loading,
    isNewPlP: t2,
    className
  } = t0;
  const hasCityPrefix = t1 === undefined ? true : t1;
  const isNewPlP = t2 === undefined ? false : t2;
  const router = useRouter();
  const isVilla = process.env.NEXT_PUBLIC_APP_NAME === "villa";
  const accommodationTitle = isVilla ? isNewPlP ? `اقامتگاه و ویلا در ${city}` : `ویلا در ${city}` : `هتل در ${city}`;
  const t3 = `text-on-surface-high-emphasis text-body-2 w-full truncate pt-5 lg:pt-0 lg:font-medium ${className}`;
  let t4;
  if ($[0] !== accommodationTitle || $[1] !== city || $[2] !== hasCityPrefix || $[3] !== isNewPlP || $[4] !== loading || $[5] !== router || $[6] !== totalItem) {
    t4 = process.env.NEXT_PUBLIC_APP_NAME === "tour" ? loading ? <h2 className="inline">در جستجوی تور‌های {city} ...</h2> : <><span>{numberConvert(totalItem, {
          locale: "fa"
        })}{" "}</span><h2 className="inline">تور {city}</h2></> : city ? hasCityPrefix ? <><span className={`${isVilla && isNewPlP ? "text-subtitle-1 pl-1" : ""}`}>{totalItem ? numberConvert(totalItem, {
          locale: router.locale
        }) : ""}</span>{" "}<h2 className={`${isVilla && isNewPlP ? "text-subtitle-1" : ""} inline`}>{accommodationTitle}</h2></> : <>{!loading && <span>{numberConvert(totalItem, {
          locale: router.locale
        })}{" "}</span>}<h2 className="inline">اقامتگاه</h2></> : <div className="h-6"><Skeleton shape="rectangle" /></div>;
    $[0] = accommodationTitle;
    $[1] = city;
    $[2] = hasCityPrefix;
    $[3] = isNewPlP;
    $[4] = loading;
    $[5] = router;
    $[6] = totalItem;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className={t3} data-testid="header_title">{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};